<div class="footerbar">

  <a class="footerbar__tab" routerLink="/taskboard" routerLinkActive [class.active]="router.url === '/taskboard'">
    <div class="footerbar__container">
      <div class="footerbar__icon-wrapper">
        <i class="material-icons footerbar__icon" id="icon--daily">alarm_on</i>
        </div>
        <div class="footerbar__menutext">
          <p> Daily </p>
          </div>
    </div>
  </a>

  <a class="footerbar__tab" routerLink="/releaseplanning" routerLinkActive [class.active]="router.url === '/releaseplanning'">
    <div class="footerbar__container">
      <div class="footerbar__icon-wrapper">
        <i class="material-icons footerbar__icon" id="icon--planning1">table_chart</i>
        </div>
        <div class="footerbar__menutext">
          <p> Releaseplanning </p>
          </div>
    </div>
  </a>

  <a class="footerbar__tab" routerLink="/sprintplanning2" [class.active]="router.url === '/sprintplanning2'">
    <div class="footerbar__container">
      <div class="footerbar__icon-wrapper">
        <i class="material-icons footerbar__icon" id="icon--planning2">view_list</i>
      </div>
      <div class="footerbar__menutext">
        <p> Sprintplanning 2</p>
      </div>
    </div>
  </a>

  <a class="footerbar__tab" routerLink="/mpc-board" [class.active]="router.url === '/mpc-board'">
    <div class="footerbar__container">
      <div class="footerbar__icon-wrapper">
        <i class="material-icons footerbar__icon" id="icon--mpc">share</i>
      </div>
      <div class="footerbar__menutext">
        <p> Multiproject </p>
      </div>
    </div>
  </a>

  <a class="footerbar__tab" routerLink="/kanban-board" [class.active]="router.url === '/kanban-board'">
    <div class="footerbar__container">
      <div class="footerbar__icon-wrapper">
        <i class="material-icons footerbar__icon" id="icon--kanban">share</i>
      </div>
      <div class="footerbar__menutext">
        <p> Kanban </p>
      </div>
    </div>
  </a>

    <!-- Customer Logo, only activated for demo-purposes -->
    <!--
    <img class="logo-customer" src="./assets/img/logo/logo_sbb.png" alt='Logo Customer' (click)="toggleCustomerLogo()"
    [ngClass]="{'not-visible' : !this.customerLogoVisible}" />
    -->
</div>
